import { typesRedux } from '../../shared/types/typesRedux';

const initialState = {
    mode: '',
    logUser: undefined,
    activeStep: 0,
    navbar: true,
};

export const generalReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case typesRedux.MODE_THEME:
            return {
                ...state,
                mode: action.payload,
            };

        case typesRedux.USER_LOG:
            return {
                ...state,
                logUser: { ...action.payload },
            };

        case typesRedux.LOGOUT_LOGIN:
            return {
                ...state,
                logUser: undefined,
                activeStep: 0,
            };

        case typesRedux.nextStepper:
            return {
                ...state,
                activeStep: state.activeStep + 1,
            };

        case typesRedux.backStepper:
            return {
                ...state,
                activeStep: state.activeStep - 1,
            };

        case typesRedux.resetStepper:
            return {
                ...state,
                activeStep: initialState.activeStep,
            };

        case typesRedux.SHOW_NAVBAR:
            return {
                ...state,
                navbar: action.payload,
            };

        default:
            return state;
    }
};
